import { ArrowCircleLeftIcon, CheckIcon } from '@heroicons/react/outline'
import { StarIcon, XCircleIcon } from '@heroicons/react/solid'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import { GetClientDataResponse } from 'shared/api/manager/ApiGlobals'
import CrmLink from 'shared/components/CrmLink'
import { parseAmount } from 'shared/lib/functions/fa'
import { RootState } from 'store/store'

import { formikValuesType } from '../../index'

// ------------------------------------classNames-------------------------
const parentClassName = '-translate-y-8 h-[640px] '
const nameClassName =
  'font-semibold text-[14px] leading-[34px] flex justify-center items-center !text-color-title3   '
const companyClassName =
  'flex justify-center font-normal text-[14px] leading-[34px] !text-color-title3'
const boxClassName =
  'px-2  font-medium text-[14px] leading-8  flex justify-center items-center rounded flex'
const financialAndHappyCallBodyClassName = 'py-[20px] px-6 border-b '
const titleClassName =
  'font-normal text-[14px] leading-[14px] text-gray-medium flex justify-center pb-3 pt-1'

const textClassName =
  'text-[14px] leading-[34px] gap-x-[10px]  !text-color-title3 flex '

const checkBadgeClassName =
  'w-[30px] h-[30px] rounded-full bg-light-green text-green-cta '
const numbersClassName = 'font-medium'
const lastHappyCallTextClassName =
  'font-medium text-[12px] leading-[34px] text-extra-dark flex items-center  gap-x-1'
// ------------------------------------end classNames-------------------------

export const ContactInfo = (props: GetClientDataResponse) => {
  const {
    contactName,
    accountName,
    companyName,
    isVIP,
    vipBroker,
    isPrePaymentRequired,
    creditBalance,
    accountBalance,
    quoteCount,
    invoiceCount,
    accountId,
    contactId,
  } = props
  const { values, setFieldValue } = useFormikContext<formikValuesType>()
  const callDetail = useSelector(
    (state: RootState) => state.callDetail.callData
  )
  console.log(contactId)
  console.log(accountId)

  const canResetLeadField = !(callDetail.accountId || callDetail.contactId)
  const parseCheckOrX = () => {
    if (isPrePaymentRequired)
      return (
        <div className={checkBadgeClassName}>
          <CheckIcon className={''} />
        </div>
      )
    else return <div className="font-medium">خیر</div>
  }

  const resetLeadField = () => {
    setFieldValue('lead', {})
  }

  return (
    <div className={parentClassName}>
      {/*-----------------------name--------------------*/}
      <div className={nameClassName} style={{ direction: 'ltr' }}>
        {canResetLeadField && (
          <XCircleIcon
            className="w-6 h-6 mr-2 cursor-pointer text-color-error"
            onClick={resetLeadField}
          />
        )}
        <CrmLink customEtc={accountId ? 1 : 2} id={accountId || contactId}>
          {(accountName as any) || contactName}
        </CrmLink>
      </div>

      {/*-----------------------company--------------------*/}
      <div className={companyClassName}>{companyName}</div>
      {/*-----------------------rnagi pangi--------------------*/}
      <div
        className={'flex flex-col px-6 border-b space-y-[18px] pt-4 pb-[20px]'}
      >
        {isVIP && vipBroker && (
          <div
            className={classNames(
              boxClassName,
              'text-medium-yellow  gap-x-2 bg-light-yellow mx-auto'
            )}
          >
            <StarIcon
              className={'fill-medium-yellow text-medium-yellow w-[20px]'}
            />
            ({vipBroker} ) VIP
          </div>
        )}
        <div className={'flex justify-between '}>
          <div
            className={classNames(
              boxClassName,
              'bg-light-green text-green-cta'
            )}
          >
            سابقه خرید: {invoiceCount} بار
          </div>
          <div
            className={classNames(
              boxClassName,
              'bg-light-orange text-orange-bullet '
            )}
          >
            استعلام قیمت:
            {quoteCount} بار
          </div>
        </div>
      </div>
      {/*-----------------------end rnagi pangi--------------------*/}

      {/*-----------------------financial --------------------*/}
      <div className={financialAndHappyCallBodyClassName}>
        <div className={titleClassName}>اطلاعات مالی</div>
        <div className={'space-y-4'}>
          <div className={textClassName}>
            مانده حساب :{''}
            <span className={numbersClassName}>
              <span style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}>
                {accountBalance &&
                  parseAmount(Number(accountBalance / 10).toFixed(0))}
              </span>{' '}
              تومان
            </span>
          </div>
          <div className={textClassName}>
            مانده اعتبار:
            <span className={numbersClassName}>
              {creditBalance &&
                parseAmount(Number(creditBalance / 10).toFixed(0))}{' '}
              تومان
            </span>
          </div>
          <div className={textClassName}>
            امکان 100 % پیش پرداخت:
            {parseCheckOrX()}
          </div>
        </div>
      </div>
      {/*----------------------- end financial --------------------*/}

      {/*-----------------------happy call --------------------*/}
      <div
        className={classNames(financialAndHappyCallBodyClassName, '!border-0')}
      >
        <div className={titleClassName}>اطلاعات هپی کال</div>
        <div className={'space-y-[14px]'}>
          <div className={textClassName}>
            آخرین وضعیت هپی کال:
            <span className={'text-green-cta font-medium text-[14px]'}>
              {' '}
              {values?.happyCallInfo?.recentStatus}
            </span>
          </div>
          <div className={lastHappyCallTextClassName}>
            مشاهده آخرین هپی کال ثبت شده
            <ArrowCircleLeftIcon className={'w-5 mb-1'} />
          </div>
        </div>
      </div>

      {/*-----------------------end happy call --------------------*/}
    </div>
  )
}
